import { Button } from 'react-bootstrap';
import { Icon } from 'modules';
import React from 'react';

interface ClearFilterProps {
  onClick: () => void;
}

const ClearFilter = (props: ClearFilterProps): React.ReactElement => {
  return (
    <Button size="sm" variant="light" className="mb-3" onClick={props.onClick}>
      <Icon type="times" />
    </Button>
  );
};

export default ClearFilter;
